/**
 * Actor pool data. Preserved from v1.
 */

export const ACTOR_IDS = [31,287,6193,380,1245,134,19292,500,16828,2888,1896,1158,3223,5292,6968,2231,85,11288,234352,3895,6885,2157,514,524,1023139,1204,5064,1461,72129,18918,11701,18277,1892,206,2227,112,1327,192,73421,10297,131,5309,19492,10205,116,9273,140,4587,776,55638,6384,17605,1267329,37917,11856,62,18897,54693,6941,934,30614,4724,10859,57755,70851,884,1813,4517,83002,64,13240,5472,1229,2963,60073,10990,880,3,3063,4784,32,53714,9281,24045,21007,5293,1532,5081,3896,10882,90633,139,71070,56734,18973,3489,9827,6161,3967,4483,1231,37153,27578,1038,3293,1283,1579,1920,204,205,36592,51329,4491,505710,2037,23659,118545,40462,27319,9642,84223,1812,12052,62561,368,68842,76788,55536,52792,108916,17628,9788,6944,16866,5723,2047,1625558,1100];

export const EXPANDED_ACTOR_IDS = [17142,17276,17419,1230,190,67773,741,723,3636,4135,2090,3359,4958,854,13294,3150,2749,10158,40,13848,4165,3460,11492,7302,12021,4970,1932,7632,9594,4070,2639,3149,10538,15385,14974,13992,4111,7570,6598,9066,3635,8857,4090,11165,2769,8944,41091,3910,9278,955,69597,5344,119592,3416,5823,35,2395,49265,15758,1160,515,6352,4430,3092,56731,9994,9137,21625,4038,501,56322,6450,7404,7056,43775,5606,16935,4687,15735,5657,59315,18686,11703,11664,1397778,17773,25540,5916,17647,10431,1772,18050,80591,34490,32798,1230868,10690,19119];

export const BOLLYWOOD_ACTOR_IDS = [35070,42802,42803,35742,52763,78749,35793,35780,84957,35747,85034,224223,78245,52971,85881,85969,72118,77235,86302,52263,76793,85889,85730,85891,87328,84956,97546,117727,85668,6497,6217,1033157,81869,37233,53975,77234,81928,130958,85040,130991,35068,55061,35776,87773,85470,550167,85035,55062,76232,35745,76233,55063,35810,86077,76450,86060,86075,123180,85890,88138,53672,95505,85883,1108120];

export const PRE_BLOCKBUSTER_IDS = [12446,11147,8487,2638,8252,4110,3151,2091,3636,4135,2090,3359,4958,854,13294,3150,2749,10158,40,13848,4165,3460,11492,7302,12021,4970,1932,7632,9594,4070,2639,3149,10538,15385,14974,13992,4111,7570,6598,9066,3635,8857,4090,11165,2769];

export const TV_ACTOR_IDS = [36801,83860,1254995,56322,6861,62861,9780,119592,2195140,86626,222121,1240868,1344739,73457,71198,21246,122756,27105,475512,1181326,1455336,543505,1624816,13636,2692283,6166,50095,51856,206905,85757,17697,65717,40462,109869,1181327,2975,51873,1407498,1213603,125167,41686,17039,25072,1745988,11678,75318,2879,968367,12836,53256,16327,134423,4252,74611,1214870,191228,1410478,1227552,118372,505710,11664,74949,205179,119589,111513,83586,161932,71727,9273,1370567,111683,1181353,13548,993774,17838,32,17419,59410,783,1253360];

export const DISNEY_NICK_ACTOR_IDS = [58965,226001,67600,28166,121868,88123,85176,75041,56730,67602,76313,123846,85138,1098962,3272,95686,206399,94818,38707,54594,133979,111512,85757,15760,74688,1254396,130566,76594,17743,212913,130565,33490,66896,1152083,77948,1331457,87569,67599,191228,29222,1254995,111513,240725,93219,80613,74929,1192274,973385];

/** Get a random subset of actor IDs from the main pool */
export function getRandomActors(count, pool = ACTOR_IDS) {
  const shuffled = [...pool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

/** Get random actors using a seeded PRNG (for daily challenge) */
export function getSeededRandomActors(count, seed, pool = ACTOR_IDS) {
  const rng = seededRandom(seed);
  const arr = [...pool];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, count);
}

/** Mulberry32 seeded PRNG */
function seededRandom(seed) {
  let s = seed | 0;
  return function() {
    s = (s + 0x6D2B79F5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Generate a daily seed from date */
export function getDailySeed(date = new Date()) {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}
